<template>
  <div class="container">
    <div class="wrap z-flex">
      <myLeft></myLeft>
      <div class="my-r">
        <myTop></myTop>
        <div class="box-con my-box">
          <div class="hd z-flex z-flex-between">
            <div class="hd-t"><i class="el-icon-bell"></i>我的收藏</div>
            <div class="tab-list z-flex">
              <div 
                :class="['item',activeTab==item.value ? 'active' : '']" 
                v-for="(item,index) in tabList" 
                :key="index"
                @click="seltab(item)"
              >
                {{item.name}}
              </div>
            </div>
          </div>
          <div class="bd">
            <!-- 收藏赛事 -->
            <div class="my-list" v-if="activeTab=='proxy_match'">
              <el-row :gutter="20">
                <el-col :span="8" v-for="(item,index) in matchList" :key="index">
                  <matchItem :itemData="item" showSta></matchItem>
                </el-col>
              </el-row>
              <!-- 结果为空 -->
              <el-empty class="empty-con" description="暂无收藏的赛事" :image-size="180" v-if="matchList.length == 0">
                <img class="img" src="../assets/images/default-list.png" slot="image"/>
                <el-button type="primary" @click="toUrl('/match/list')">查看更多赛事</el-button>
              </el-empty>
            </div>
            <!-- 收藏课程 -->
            <div class="my-list" v-if="activeTab=='edu_course'">
              <el-row :gutter="20">
                <el-col :span="8" v-for="(item,index) in courseList" :key="index">
                  <courseItem :itemData="item"></courseItem>
                </el-col>
              </el-row>
              <!-- 结果为空 -->
              <el-empty class="empty-con" description="暂无收藏的课程" :image-size="180" v-if="courseList.length == 0">
                <img class="img" src="../assets/images/default-list.png" slot="image"/>
                <el-button type="primary" @click="toUrl('/course/list')">查看更多课程</el-button>
              </el-empty>
            </div>
            <!-- 收藏采风 -->
            <div class="my-list" v-if="activeTab=='caifeng'">
              <el-row :gutter="20">
                <el-col :span="8" v-for="(item,index) in caifengList" :key="index">
                  <caifengItem :itemData="item" showSta></caifengItem>
                </el-col>
              </el-row>
              <!-- 结果为空 -->
              <el-empty class="empty-con" description="暂无收藏的采风活动" :image-size="180" v-if="caifengList.length == 0">
                <img class="img" src="../assets/images/default-list.png" slot="image"/>
                <el-button type="primary" @click="toUrl('/caifeng/list')">查看更多采风活动</el-button>
              </el-empty>
            </div>
            <!-- 收藏影展 -->
            <div class="my-list" v-if="activeTab=='exhibition'">
              <el-row :gutter="20">
                <el-col :span="8" v-for="(item,index) in exhibitionList" :key="index">
                  <exhibitionItem :itemData="item"></exhibitionItem>
                </el-col>
              </el-row>
              <!-- 结果为空 -->
              <el-empty class="empty-con" description="暂无收藏的影展活动" :image-size="180" v-if="exhibitionList.length == 0">
                <img class="img" src="../assets/images/default-list.png" slot="image"/>
                <el-button type="primary" @click="toUrl('/exhibition/list')">查看更多影展活动</el-button>
              </el-empty>
            </div>
            <!-- 收藏获奖 -->
            <div class="my-list" v-if="activeTab=='prize'">
              <el-row :gutter="20">
                <el-col :span="8" v-for="(item,index) in prizeList" :key="index">
                  <prizeItem :itemData="item"></prizeItem>
                </el-col>
              </el-row>
              <!-- 结果为空 -->
              <el-empty class="empty-con" description="暂无收藏的获奖信息" :image-size="180" v-if="prizeList.length == 0">
                <img class="img" src="../assets/images/default-list.png" slot="image"/>
                <el-button type="primary" @click="toUrl('/prize/list')">查看更多获奖信息</el-button>
              </el-empty>
            </div>
            <!-- 分页 -->
            <el-pagination 
              class="pagination" 
              background 
              layout="prev, pager, next" 
              :total="totalNum"
              :page-size="length"
              hide-on-single-page
              @current-change="changePage"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import myLeft from "@/components/my/myLeft";
import myTop from "@/components/my/myTop";
import matchItem from '@/components/item/matchItem';
import caifengItem from '@/components/item/caifengItem';
import exhibitionItem from '@/components/item/exhibitionItem';
import courseItem from '@/components/item/courseItem';
import prizeItem from '@/components/item/prizeItem';
export default {
  components: {
    myLeft,
    myTop,
    matchItem,
    caifengItem,
    exhibitionItem,
    courseItem,
    prizeItem,
  },
  data() {
    return {
      curPage:1,
      totalNum:0,
      length: 20,
      matchList:[],
      courseList:[],
      exhibitionList:[],
      caifengList:[],
      prizeList:[],
      activeTab:'proxy_match',
      tabList:[
        {
          value:'proxy_match',
          name:'赛事',
        },{
          value:'edu_course',
          name:'课程',
        },{
          value:'caifeng',
          name:'采风',
        },{
          value:'exhibition',
          name:'影展',
        },{
          value:'prize',
          name:'获奖',
        },
      ],
    };
  },
  computed: {
    
  },
  mounted() {
    this.getRows();
    // this.getNearMatch();
  },
  methods: {
    toUrl(url){
      this.$router.push({
        path:url,
      })
    },
    //分页
    changePage(e){
      this.curPage = e;
      this.getRows();
    },
    seltab(item){
      this.curPage = 1;
      this.activeTab = item.value;
      this.getRows();
    },
    // 近期赛事
    getNearMatch(){
      const loading = this.$loading({target:'.my-list',});
      this.$axios.api.request({
        url: "/api/qtclub/index/getNearMatch",
      }, (res) => {
        loading.close();
        this.matchList = res.data;
      })
    },
    // 获取列表数据
    getRows(){
      const loading = this.$loading({target:'.list-con',});
      let offset = (this.curPage-1)*this.length;
      this.$axios.api.request({
        url: "/api/qtclub/user/getCollectList",
        method: "GET",
        data: {
          offset: offset,
          length: this.length,
          object: this.activeTab
        }
      }, (res) => {
        loading.close();
        if(this.activeTab == 'proxy_match'){
          this.matchList = res.data.list;
        }else if(this.activeTab == 'edu_course'){
          this.courseList  = res.data.list;
        }else if(this.activeTab == 'exhibition'){
          this.exhibitionList  = res.data.list;
        }else if(this.activeTab == 'caifeng'){
          this.caifengList  = res.data.list;
        }
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.wrap{
  align-items: flex-start;
}
.my-box{
  padding:20px;
  .hd{
    margin-bottom: 25px;
    .hd-t{
      font-size: 18px;
      i{
        margin-right: 10px;
        color: $colorMain;
      }
    }
    .tab-list{
      .item{
        color: #777;
        cursor: pointer;
        padding: 0 20px;
        position: relative;
        height: 20px;
        line-height: 20px;
        &::after{
          content:"";
          width:1px;
          height:14px;
          display: block;
          background:#ddd;
          position: absolute;
          left: 0;
          top: 50%;
          margin-top: -7px;
        }
        &:first-child::after{
          display: none;
        }
        &:hover{
          color: $colorMain;
        }
        &.active{
          color: $colorMain;
        }
      }
    }
  }
}
</style>
